import { BaseApi } from './base.api.js';

export class ComplianceFrameworkApi extends BaseApi {
    constructor(client) {
        super(client, '/compliance-framework');
    }
}
